import {FormikProps} from 'formik';
import {ChangeEvent} from 'react';
import LikeInputOutlet from '../../../../components/IlikeIputOutlet';
import {IProductForm} from './productFormData';

interface IProps {
  form: FormikProps<IProductForm>;
}

const EnginePower = ({form}: IProps) => {
  return (
    <section>
      <p className="mb-2 color-gray-1 text-md">
        قدرت موتور <span className="text-sm text-gray-600">(اسب بخار)</span>
      </p>

      <LikeInputOutlet
        name="enginePower"
        label=""
        value={form?.values?.enginePower || ''}
        placeholder="قدرت موتور را وارد کنید"
        type="number"
        touched={!!form?.values.enginePower}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          form.setFieldValue('enginePower', e.target.value);
        }}
      />
    </section>
  );
};

export default EnginePower;
